module.exports = __webpack_public_path__ + "img/productBgImg27.c7b43467.png";